
export default {
  data() {
    return {
      // 当前tooltip
      tooltipRef: 'tooltip',
      // 防抖
      tooltipDebounce: null
    };
  },
  methods: {
    // 鼠标滑入
    tooltipMouseEnterHandler(event, callBack) {
      const cell = event.target;
      if (cell) {
        const range = document.createRange();
        range.setStart(cell, 0);
        range.setEnd(cell, cell.childNodes.length);
        let style = window.getComputedStyle(cell);
        // 当前行高
        const lineHeight = style.lineHeight.slice(0, -2);
        const rangeClient = range.getBoundingClientRect();
        const rangeWidth = rangeClient.width;
        const rangeHeight = rangeClient.height;
        const cellWidth = cell.offsetWidth;
        const cellHeight = cell.offsetHeight;
        const rangeLine = Math.floor(rangeHeight / lineHeight);
        const cellLine = Math.floor(cellHeight / lineHeight);
        if (rangeWidth > cellWidth || rangeHeight > cellHeight) {
          const tooltip = this.$refs[this.tooltipRef];
          tooltip.setExpectedState(false);
          tooltip.handleClosePopper();
          // 设置tooltip内容
          this.tooltipContent = cell.innerText || cell.textContent;
          tooltip.referenceElm = cell;
          tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
          tooltip.doDestroy();
          tooltip.setExpectedState(true);
          // 添加防抖
          if (this.tooltipDebounce) {
            clearTimeout(this.tooltipDebounce);
          }
          this.tooltipDebounce = setTimeout(() => {
            // 打开tooltip
            tooltip.handleShowPopper();
            if (callBack && typeof callBack == 'function') {
              callBack();
            }
            clearTimeout(this.tooltipDebounce);
          }, 500);
        }
      }
    },
    // 鼠标划出
    tooltipMouseLeaveHandler() {
      if (this.tooltipDebounce) {
        clearTimeout(this.tooltipDebounce);
      }
      this.tooltipDebounce = setTimeout(() => {
        const tooltip = this.$refs[this.tooltipRef];
        if (tooltip) {
          tooltip.setExpectedState(false);
          tooltip.handleClosePopper();
        }
        clearTimeout(this.tooltipDebounce);
      }, 300);
    },
    tooltipBoxMouseEnterHandler() {
      if (this.tooltipDebounce) {
        clearTimeout(this.tooltipDebounce);
      }
    },
    tooltipBoxMouseLeaveHandler() {
      const tooltip = this.$refs[this.tooltipRef];
      if (tooltip) {
        tooltip.setExpectedState(false);
        tooltip.handleClosePopper();
      }
    }
    // methods end;
  }
};
